"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PhaseBase = /** @class */ (function () {
    function PhaseBase() {
    }
    return PhaseBase;
}());
exports.PhaseBase = PhaseBase;
//export class PhaseProductBase extends PhaseBase {
//    public targetProductInstanceId: string;
//    public targetProductInstance: cm.ProductDefinitionInstance;
//    public targetProductDefinitionId: string;
//    public targetProductDefinition: cm.ProductDefinition;
//}
//export class PhaseWorkTypeBase extends PhaseBase {
//  public targetWorkTypeId: string;
//  public targetWorkType: cm.WorkType;
//}
//export class ProductLineProductHeadReadOnly extends PhaseProductBase {
//    public units: cm.DeliverableUnits;
//    public completed: boolean;
//    public started: boolean;
//    public actions: cm.PhaseActions;
//    public parent: dro.DeliverableTopReadOnly;
//    public instances: Array<dro.DeliverableProductHeadReadOnly>;
//    public placeholders: Array<dro.PlaceholderProductHeadReadOnly>;
//}
//export class ProductLineWorkTypeHeadReadOnly extends PhaseWorkTypeBase { 
//  public units: cm.DeliverableUnits;
//  public completed: boolean;
//  public started: boolean;
//  public actions: cm.PhaseActions;
//  public parent: dro.DeliverableTopReadOnly;
//  public instances: Array<dro.DeliverableWorkTypeHeadReadOnly>;
//  public placeholders: Array<dro.PlaceholderWorkTypeHeadReadOnly>;
//}
// only in client
var ProductLineCommonReadOnly = /** @class */ (function (_super) {
    __extends(ProductLineCommonReadOnly, _super);
    function ProductLineCommonReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProductLineCommonReadOnly;
}(PhaseBase));
exports.ProductLineCommonReadOnly = ProductLineCommonReadOnly;
var ProductLineProductHeadReadOnly = /** @class */ (function (_super) {
    __extends(ProductLineProductHeadReadOnly, _super);
    function ProductLineProductHeadReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProductLineProductHeadReadOnly;
}(ProductLineCommonReadOnly));
exports.ProductLineProductHeadReadOnly = ProductLineProductHeadReadOnly;
var ProductLineWorkTypeHeadReadOnly = /** @class */ (function (_super) {
    __extends(ProductLineWorkTypeHeadReadOnly, _super);
    function ProductLineWorkTypeHeadReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProductLineWorkTypeHeadReadOnly;
}(ProductLineCommonReadOnly));
exports.ProductLineWorkTypeHeadReadOnly = ProductLineWorkTypeHeadReadOnly;
var ProductLineUnAssignedReadOnly = /** @class */ (function (_super) {
    __extends(ProductLineUnAssignedReadOnly, _super);
    function ProductLineUnAssignedReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProductLineUnAssignedReadOnly;
}(ProductLineCommonReadOnly));
exports.ProductLineUnAssignedReadOnly = ProductLineUnAssignedReadOnly;
var ProductLineProductChildReadOnly = /** @class */ (function (_super) {
    __extends(ProductLineProductChildReadOnly, _super);
    function ProductLineProductChildReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProductLineProductChildReadOnly;
}(ProductLineCommonReadOnly));
exports.ProductLineProductChildReadOnly = ProductLineProductChildReadOnly;
var ProductLineWorkTypeChildReadOnly = /** @class */ (function (_super) {
    __extends(ProductLineWorkTypeChildReadOnly, _super);
    function ProductLineWorkTypeChildReadOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProductLineWorkTypeChildReadOnly;
}(ProductLineCommonReadOnly));
exports.ProductLineWorkTypeChildReadOnly = ProductLineWorkTypeChildReadOnly;
